import * as React from 'react';
import { useSelector } from 'react-redux';
import { AnimatedContainer } from '../../components/AnimatedContainer';
import { Advantages, Advantage } from '../../components/LandingPageV2/Advantages';
import { selectIsAnimationAvailable } from '../../selectors/pageState';

type IType = 'time' | 'reliability' | 'wishes' | 'price';

const DEFAULT_CONTENT: { title: string; description: string; type: IType }[] = [
  {
    title: 'Сэкономим ваше\u00A0время',
    description: `Отсмотрим тысячи объявлений\u00A0за\u00A0вас`,
    type: 'time',
  },
  {
    title: 'Знаем надёжных застройщиков',
    description: `Проверяем сроки сдачи, документы, фото со\u00A0стройки`,
    type: 'reliability',
  },
  {
    title: 'Учтём любые пожелания',
    description: 'Бюджет, район, планировку\u00A0— всё, что\u00A0вам\u00A0важно',
    type: 'wishes',
  },
  { title: 'И\u00A0всё\u00A0это\u00A0— бесплатно', description: '', type: 'price' },
];

export const AdvantagesContainer = () => {
  const isAnimationAvailable = useSelector(selectIsAnimationAvailable);

  return (
    <Advantages>
      {DEFAULT_CONTENT.map(item => (
        <AnimatedContainer key={item.title} isAnimationAvailable={isAnimationAvailable}>
          <Advantage key={item.title} {...item} />
        </AnimatedContainer>
      ))}
    </Advantages>
  );
};
